/* Global JavaScript for Shopify theme */

// Initialize theme when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('Shopify theme loaded');
  
  // Initialize all theme components
  initTheme();
});

// Main theme initialization function
function initTheme() {
  // Initialize accordion if present
  if (typeof initAccordion === 'function') {
    initAccordion();
  }
  
  // Initialize topbar if present
  if (typeof initTopbarCarousel === 'function') {
    initTopbarCarousel();
  }
  
  // Initialize footer if present
  if (typeof initFooterCarousel === 'function') {
    initFooterCarousel();
  }
  
  
  console.log('Theme components initialized');
}

// Utility functions
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}

// Export functions for use in other scripts
window.ShopifyTheme = {
  init: initTheme,
  debounce: debounce,
  throttle: throttle
};
